var THREE = require("three");

if(THREE){
    var ThreejsDefaults = {
        boardBuffer: 16000,
        copperHeight: 34,
        solderPasteHeight: 35,
        silkscreenHeight: 40,
        documentationHeight: 36,
        assemblyHeight: 36,
        boardThickness: 1600,
        copperMaterial:  new THREE.MeshPhongMaterial({
            flatShading: true,
            color: 0xDAC135,
            specular: 0x666622,
            shininess:40
        }),

        solderPasteMaterial:  new THREE.MeshPhongMaterial({
            flatShading: true,
            color: 0x7c7555,//TODO
            specular: 0xffffff,
            shininess:0
        }),
        
        silkscreenMaterial: new THREE.MeshPhongMaterial({
            flatShading: true,
            color: 0xffffff,
            specular: 0xffffff,
            shininess: 0
        }),
        packageMaterial: new THREE.MeshPhongMaterial( {
            flatShading: true,
            color: 0x555555,
            specular: 0xffffff,
            shininess: 5,
            transparent: false,
            opacity: 1
        }),
        boardMaterial: new THREE.MeshPhongMaterial( {
            flatShading: true,
            color: 0x025702,
            specular: 0x003409,
            shininess: 10
        }),

        documentationMaterial: new THREE.MeshPhongMaterial( {
            flatShading: true,
            color: 0x8D8D8D,
            shininess: 0
        }),

        assemblyMaterial: new THREE.MeshPhongMaterial( {
            flatShading: true,
            color: 0x8D8D8D,
            shininess: 0
        }),

        holePrecision: 1,
        copperPrecision: 1,
        silkscreenPrecision: 3,
        traceEndSegments: 8,
        silkscreenEndSegments: 4
    };

    ThreejsDefaults.unexposedCopperMaterial = new THREE.MeshPhongMaterial({
        flatShading: true,
        color: new THREE.Color(new THREE.Color(ThreejsDefaults.copperMaterial.color).lerp(new THREE.Color(ThreejsDefaults.boardMaterial.color), 0.9)),
        specular: 0x666622,
        shininess:20
    });
}

module.exports = ThreejsDefaults;